// extracted by mini-css-extract-plugin
export default {"loading_container":"List_loading_container__BbW+d","message_list":"List_message_list__7DGC-","loading":"List_loading__E9dVE"};